import { faClose } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import "../../styles/alert.css";

export const AppAlert = ({caption,message,accept,reject,onAccept,onReject, closeAlert}) => {
    return (
        <div className="alert-container">
            <div className="alert-box">
                <div className="alert-box-closer">
                    <button className="closer-button" onClick={closeAlert}>
                        <FontAwesomeIcon icon={faClose}  size={32} />
                    </button>
                </div>
                <div className="alert-box-content">
                    <div className="alert-box-caption">{caption}</div>
                    <div className="alert-box-text">{message}</div>
                </div>
                <div className="action-box">
                    {accept && <button className="action-button" onClick={onAccept}>{accept}</button>}
                    {reject && <button className="action-button" onClick={onReject}>{reject}</button>}
                </div>
            </div>
        </div>
    )
}